<template>
	<div>
		<div class="text-c mt-10">
			<el-button @click="打印()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="success" icon="el-icon-printer">打印</el-button>
			<el-button @click="关闭页面()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="danger" icon="el-icon-close">关闭</el-button>
		</div>
		<div id="dayin1">
			<h1 class="text-c c-orange">{{ 查看表单.车牌号码 }}车辆信息表</h1>
			<table style="width:240mm;table-layout: fixed;" class="table radius mt-10 table-yanse f-14" border="1" cellpadding="1" align="center">
				<tr>
					<td width="22%" class="c-error f-16">车辆编号：</td>
					<td width="28%" class="c-blue f-16">{{ cheliangbianhao }}</td>
					<td width="22%" class="c-error f-16">车牌号码：</td>
					<td width="28%" class="c-blue f-16">{{ 查看表单.车牌号码 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">名称：</td>
					<td class="c-blue f-16">{{ 查看表单.名称 }}</td>
					<td class="c-error f-16">车型：</td>
					<td class="c-blue f-16">{{ 查看表单.车型 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">车辆类型：</td>
					<td class="c-blue f-16">{{ 查看表单.车辆类型 }}</td>
					<td class="c-error f-16">使用性质：</td>
					<td class="c-blue f-16">{{ 查看表单.使用性质 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">车辆所有人：</td>
					<td class="c-blue f-16">{{ 查看表单.车辆所有人 }}</td>
					<td class="c-error f-16">车辆分类：</td>
					<td class="c-blue f-16">{{ 查看表单.车辆分类 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">品牌型号：</td>
					<td class="c-blue f-16">{{ 查看表单.品牌型号 }}</td>
					<td class="c-error f-16">发动机排量：</td>
					<td class="c-blue f-16">{{ 查看表单.发动机排量 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">整备质量：</td>
					<td class="c-blue f-16">{{ 查看表单.整备质量 }}</td>
					<td class="c-error f-16">总质量：</td>
					<td class="c-blue f-16">{{ 查看表单.总质量 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">核定载人数：</td>
					<td class="c-blue f-16">{{ 查看表单.核定载人数 }}</td>
					<td class="c-error f-16">车身颜色：</td>
					<td class="c-blue f-16">{{ 查看表单.车身颜色 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">发动机号码：</td>
					<td class="c-blue f-16">{{ 查看表单.发动机号码 }}</td>
					<td class="c-error f-16">车辆识别代号：</td>
					<td class="c-blue f-16">{{ 查看表单.车辆识别代号 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">行驶证注册日期：</td>
					<td class="c-blue f-16">{{ 查看表单.行驶证注册日期 }}</td>
					<td class="c-error f-16">行驶证发证日期：</td>
					<td class="c-blue f-16">{{ 查看表单.行驶证发证日期 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">登记证书号</td>
					<td class="c-blue f-16">{{ 查看表单.登记证书号 }}</td>
					<td class="c-error f-16">单位</td>
					<td class="c-blue f-16">{{ 查看表单.单位 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">类型</td>
					<td class="c-blue f-16">{{ 查看表单.车辆编号 }}</td>
					<td class="c-error f-16">类别：</td>
					<td class="c-blue f-16">{{ 查看表单.车辆编号 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">驾驶员：</td>
					<td class="c-blue f-16">{{ 查看表单.驾驶员 }}</td>
					<td class="c-error f-16">驾驶员手机</td>
					<td class="c-blue f-16">{{ 查看表单.驾驶员手机 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">保留车牌：</td>
					<td class="c-blue f-16">{{ 查看表单.保留车牌 }}</td>
					<td class="c-error f-16">轮胎规格</td>
					<td class="c-blue f-16">{{ 查看表单.轮胎规格 }}</td>
				</tr>
				<tr>
					<td class="c-error f-16">备注</td>
					<td colspan="3" class="c-blue f-16">{{ 查看表单.备注 }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'clxx-view',
	props: {
		cheliangbianhao: Number
	},
	data() {
		return {
			用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
			查看表单: {
				车牌号码: '',
				名称: '',
				车型: '',
				车辆类型: '',
				使用性质: '',
				车辆所有人: '',
				车辆分类: '',
				品牌型号: '',
				发动机排量: '',
				整备质量: '',
				总质量: '',
				核定载人数: '',
				车身颜色: '',
				发动机号码: '',
				车辆识别代号: '',
				登记证书号: '',
				行驶证注册日期: '',
				行驶证发证日期: '',
				类型: '',
				类别: '',
				单位: '',
				保留车牌: '',
				驾驶员: '',
				驾驶员手机: '',
				轮胎规格: '',
				卖出日期: '',
				卖出价格: '',
				驾驶证类型: '',
				备注: ''
			}
		};
	},
	created: function() {
		this.查询信息();
	},
	methods: {
		查询信息() {
			this.$http
				.post('cheliang/clxx/get', {
					车辆编号: this.cheliangbianhao
				})
				.then(返回数据 => {
					//console.log(返回数据);
					this.查看表单.车牌号码 = 返回数据.车辆信息.车牌号码;
					this.查看表单.名称 = 返回数据.车辆信息.名称;
					this.查看表单.车型 = 返回数据.车辆信息.车型;
					this.查看表单.车辆类型 = 返回数据.车辆信息.车辆类型;
					this.查看表单.使用性质 = 返回数据.车辆信息.使用性质;
					this.查看表单.车辆所有人 = 返回数据.车辆信息.车辆所有人;
					this.查看表单.车辆分类 = 返回数据.车辆信息.车辆分类;
					this.查看表单.品牌型号 = 返回数据.车辆信息.品牌型号;
					this.查看表单.发动机排量 = 返回数据.车辆信息.发动机排量;
					this.查看表单.整备质量 = 返回数据.车辆信息.整备质量;
					this.查看表单.总质量 = 返回数据.车辆信息.总质量;
					this.查看表单.核定载人数 = 返回数据.车辆信息.核定载人数;
					this.查看表单.车身颜色 = 返回数据.车辆信息.车身颜色;
					this.查看表单.发动机号码 = 返回数据.车辆信息.发动机号码;
					this.查看表单.车辆识别代号 = 返回数据.车辆信息.车辆识别代号;
					this.查看表单.登记证书号 = 返回数据.车辆信息.登记证书号;
					this.查看表单.行驶证注册日期 = 返回数据.车辆信息.行驶证注册日期;
					this.查看表单.行驶证发证日期 = 返回数据.车辆信息.行驶证发证日期;
					this.查看表单.类型 = 返回数据.车辆信息.类型;
					this.查看表单.类别 = 返回数据.车辆信息.类别;
					this.查看表单.单位 = 返回数据.车辆信息.单位;
					this.查看表单.保留车牌 = 返回数据.车辆信息.保留车牌;
					this.查看表单.驾驶员 = 返回数据.车辆信息.驾驶员;
					this.查看表单.驾驶员手机 = 返回数据.车辆信息.驾驶员手机;
					this.查看表单.轮胎规格 = 返回数据.车辆信息.轮胎规格;
					this.查看表单.卖出日期 = 返回数据.车辆信息.卖出日期;
					this.查看表单.卖出价格 = 返回数据.车辆信息.卖出价格;
					this.查看表单.驾驶证类型 = 返回数据.车辆信息.驾驶证类型;
					this.查看表单.备注 = 返回数据.车辆信息.备注;
				});
		},
		关闭页面() {
			//console.log(111);
			this.$emit('close', false);
		},
		打印() {
			var mywindow = window.open('', 'PRINT');
			mywindow.document.write('<html><head><title>' + document.title + '</title>');
			mywindow.document.write(
				'<style type="text/css">table{width:100%;height: 100%;empty-cells:show;background-color:transparent;border-collapse:collapse;border-spacing:0}table th{text-align:center; font-weight:400}.radius{border-radius:4px}.table-yanse{border: thin solid #ff0000;}.mt-5{margin-top:5px}.mt-10{margin-top:10px}.mt-15{margin-top:15px}.mt-20{margin-top:20px}.mt-25{margin-top:25px}.mt-30{margin-top:30px}.f-12{font-size:12px}.f-14{font-size:14px}.f-16{font-size:16px}.f-18{font-size:18px}.text-c{text-align:center}.c-red,.c-red a,a.c-red{color:red}.c-blue,.c-blue a,a.c-blue{color:blue}.c-danger,.c-danger a,a.c-danger{color:#dd514c}.c-warning,.c-warning a,a.c-warning{color:#f37b1d}.c-error,.c-error a,a.c-error{color:#c00}.c-orange,.c-orange a,a.c-orange{color:orange}td{padding: 10px;}</style>'
			);
			mywindow.document.write('</head><body >');
			mywindow.document.write(document.getElementById('dayin1').innerHTML);
			mywindow.document.write('</body></html>');
		
			mywindow.document.close(); // necessary for IE >= 10
			mywindow.focus(); // necessary for IE >= 10*/
		
			mywindow.print();
			mywindow.close();
		
			return true;
		},
	}
};
</script>
